export default "__VITE_ASSET__C0tb_FfB__"